import React from "react";

import { CaretLeft, CaretRight } from "phosphor-react";
import PropTypes from "prop-types";

import PaginationItem from "./PaginationItem";

function Pagination({
  lastPage,
  currentPage,
  onPaginate,
  neightborsPages = 3,
}) {
  const previous = () => {
    onPaginate(currentPage === 1 ? 1 : currentPage - 1);
  };

  const next = () => {
    onPaginate(currentPage === lastPage ? currentPage : currentPage + 1);
  };

  let prevPages = [];
  let nextPages = [];

  for (let i = 1; i <= neightborsPages; i++) {
    const prevPage = currentPage - i;
    const nextPage = currentPage + i;

    if (prevPage >= 1) {
      prevPages.push(prevPage);
    }

    if (nextPage <= lastPage) {
      nextPages.push(nextPage);
    }
  }

  return lastPage === 1 ? null : (
    <div className="space-x-2 flex justify-center items-center text-sm">
      {currentPage !== 1 && (
        <PaginationItem
          title={
            <div className="my-0.5">
              <CaretLeft weight="bold" />
            </div>
          }
          onClick={previous}
        />
      )}

      {prevPages.reverse().map((p) => (
        <PaginationItem key={p} title={p} onClick={() => onPaginate(p)} />
      ))}
      <PaginationItem title={currentPage} current />
      {nextPages.map((p) => (
        <PaginationItem key={p} title={p} onClick={() => onPaginate(p)} />
      ))}
      {currentPage !== lastPage && (
        <PaginationItem
          title={
            <div className="my-0.5">
              <CaretRight weight="bold" />
            </div>
          }
          onClick={next}
        />
      )}
    </div>
  );
}

Pagination.propTypes = {
  lastPage: PropTypes.number,
  currentPage: PropTypes.number,
  onPaginate: PropTypes.func.isRequired,
  neightborsPages: PropTypes.number,
};

export default Pagination;
